import { Button, Typography, useDevice } from "design_system/src";
import React, { useEffect, useMemo, useState } from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";

export interface ShowMoreCardProps {
  progress?: number;
  reactGA?: {
    name: string;
    category: string;
    label: string;
  }
}
const ShowMoreCard: React.FC<ShowMoreCardProps> = ({ progress, reactGA }) => {
  const { isTablet: isTabletDevice, isDesktop: isDesktopDevice, isLoading } = useDevice();
  const [isDesktop, setIsDesktop] = useState<boolean>();

  useEffect(() => {
    if (!isLoading) {
      setIsDesktop(isDesktopDevice && !isTabletDevice);
    }
  }, [isTabletDevice, isDesktopDevice, isLoading]);

  const position = useMemo<number>(
    // eslint-disable-next-line no-nested-ternary
    () => progress !== undefined
      ? (progress <= 1 ? Math.max(progress - 0.5, 0) : 0.5)
      : 0,
    [progress]
  );

  const handleButton = () =>{
    if (reactGA) {
      ReactGA.event(reactGA.name, {
        category: reactGA.category,
        label: reactGA.label,
      });
    }
  };

  return (
    <div className="pos_relative w_100_per">
      <div
        className="display_flex flex_col flex_align_center flex_justify_center p_y_xxl p_x_xl"
        style={!isDesktop ? {} : {
          width: "400px",
          position: "absolute",
          left: `${Math.max(position * window.outerWidth - (400 / 3), 0)}px`,
          top: `${position > 0 ? 50 : 0}%`,
        }}
      >
        <Typography
          weight="400"
          scale="large"
          className="m_b_md text_center"
        >
          Ellos también empezaron con un sueño. Hoy ya están rodando su moto. ¿Y tú? Da el primer paso con Ozon.
        </Typography>

        <Link to="/nosotros">
          <Button className="w_100_per_desktop" onClick={handleButton}>
            <Typography
              weight="600"
              scale="medium"
            >
              Conocer más testimonios acá
            </Typography>
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ShowMoreCard;
